import { pipe, prop } from 'ramda'
import { getMinutesFromDuration } from '@/helpers/getTimeFromDuration.js'
import { formatTimeFromUtc, formatDate } from '@/helpers/dateTimeFormatter.js'
import { addMinutes, endOfDay } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const getTimeslotParts = minutes => {
  return minutes / 15 // 15 is default height of a timebox
}

export const getBookingCardHeight = pipe(
  prop('Duration'),
  getMinutesFromDuration,
  getTimeslotParts,
  x => x * 60 - 7,
)

export const getTimeShort = dateTimeUtc => (locale, timezone) =>
  formatTimeFromUtc(locale)(timezone)(dateTimeUtc).substring(0, 5) //substring is to cut off AM/PM

export const getCurrentTimeLinePosition = (timeNowInZonedTime, openingDateTimeInZonedTime) => {
  const getTimeLineDifferenceInHours = (timeNowInZonedTime, openingDateTimeInZonedTime) =>
    (timeNowInZonedTime.getTime() - openingDateTimeInZonedTime.getTime()) / 1000 / 60 / 60

  return pipe(getTimeLineDifferenceInHours, s => s * 240)(
    timeNowInZonedTime,
    openingDateTimeInZonedTime,
  )
}

export const getTimeColumns = (openingDateTime, locale, timezone) => {
  const openingDateTimeInZonedTime = utcToZonedTime(openingDateTime, timezone)
  const timeColumns = []
  let minutesToAdd = 0
  for (let i = 0; i < getTimeColumnsNumber(openingDateTimeInZonedTime); i++) {
    timeColumns[i] = {
      time: getTimeShort(addMinutes(new Date(openingDateTime), minutesToAdd))(locale, timezone),
      date: addMinutes(openingDateTimeInZonedTime, minutesToAdd),
    }
    minutesToAdd = minutesToAdd + 15
  }
  return timeColumns
}

export const bookingProductStartEndTime = (startDateTime, endDateTime, locale, timezone) => {
  const startTime = formatTimeFromUtc(locale)(timezone)(startDateTime)
  const endTime = formatTimeFromUtc(locale)(timezone)(endDateTime)
  return `${startTime} - ${endTime}`
}

export const bookingProductDate = (dateTime, locale) => {
  return formatDate({
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: undefined,
    minute: undefined,
  })(locale)(dateTime)
}

const getTimeColumnsNumber = openingDateTimeInZonedTime => {
  const diff =
    Math.abs(
      openingDateTimeInZonedTime.getTime() - endOfDay(openingDateTimeInZonedTime).getTime(),
    ) / 3600000
  return Math.round(diff * 4)
}
